import { render, staticRenderFns } from "./testcenter.vue?vue&type=template&id=9f1fe026&scoped=true"
import script from "./testcenter.vue?vue&type=script&lang=js"
export * from "./testcenter.vue?vue&type=script&lang=js"
import style0 from "./testcenter.vue?vue&type=style&index=0&id=9f1fe026&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f1fe026",
  null
  
)

export default component.exports